import { createSlice, createAsyncThunk, bindActionCreators } from '@reduxjs/toolkit';


const initialState = {
    isOtpOngoing: false,
    otpMessage: "",
    otpErrorMessage: "",
    goToLogin: false,
    otpKey: "",
    allowToResend: false,
    currentUserEmail: "",
    isVerifying: false,
    resendingOtp: false,
};


export const createOtpSlice = () => {
    return createSlice({
        name: "otp",
        initialState,
        reducers: {
            resetState: () => initialState,
            clearOtpMessage(state) {
                state.otpMessage = "";
            },

            clearOtpKey(state) {
                state.otpKey = "";
            },
        },

        extraReducers: (builder) => {
            builder
                .addCase(verifyOtp.pending, (state) => {
                    state.isVerifying = true;
                })
                .addCase(verifyOtp.fulfilled, (state, action) => {
                    state.isVerifying = false;
                    const success = action.payload.success;
                    if (success) {
                        state.goToLogin = true;
                    } else {
                        let message = action.payload.message;

                        if (message === "Invalid or expired OTP") {
                            message = "Oops! Your OTP is invalid or has expired.";
                        }
                        state.otpErrorMessage = message;
                    }
                })
                .addCase(verifyOtp.rejected, (state, action) => {
                    state.isVerifying = false;
                    
                    state.otpErrorMessage = action.payload.message;
                });


            builder
                .addCase(resendOtp.pending, (state) => {
                    state.resendingOtp = true;
                })
                .addCase(resendOtp.fulfilled, (state, action) => {
                    state.resendingOtp = false;
                })
                .addCase(resendOtp.rejected, (state, action) => {
                    state.resendingOtp = false;
                })
        }
    });
};


export const verifyOtp = createAsyncThunk(
    "login/otp",

    async (credentials, { rejectWithValue, extra }) => {
        const userRepository = extra.userRepository;
        const { email, otp } = credentials;
        const emailVal = email.trim();
        const otpVal = otp.trim();

        let success = true;
        let otpMessage = "";

        if (!otpVal) {
            otpMessage = "OTP is required";
            success = false;
        }

        if (!success) {
            return rejectWithValue({ otpMessage });
        }

        try {
            const result = await userRepository.validateOtp(emailVal, otpVal);
            return result;
        } catch (error) {
            return rejectWithValue({ otpMessage: error.message });
        }

    }

)

export const getUser = createAsyncThunk(
    'user/getUser',
    async (credentials, { rejectWithValue, extra }) => {
        const userRepository = extra.userRepository;
    const result = await userRepository.getUser();
        return result;
    }
)


export const resendOtp = createAsyncThunk(
    'login/resend-otp',
    async (credentials, { rejectWithValue, extra }) => {
        const userRepository = extra.userRepository;
        const { email } = credentials;
        const emailVal = email.trim();
        try {
            const result = await userRepository.resendOtp(emailVal);
            return result;
        } catch (error) {
            return rejectWithValue({ otpMessage: error.message });
        }
    }
)